import clsx from 'clsx'
import React from 'react'
import {KTSVG} from '../../../helpers'

type Option = {
  id: string
  label: string
}

type Props = {
  label: string
  options: Option[]
  selectedOption: string
  onSelectOption: (id: string) => void
  onMainClick: () => void
  variant?: 'primary' | 'light'
  icon?: React.ReactNode
  fullWidth?: boolean
  loading?: boolean
  disabled?: boolean
}

const SplitButtonDropdown: React.FC<Props> = ({
  label,
  options,
  selectedOption,
  onSelectOption,
  onMainClick,
  variant = 'primary',
  icon,
  fullWidth = false,
  loading = false,
  disabled = false,
}) => {
  const isPrimary = variant === 'primary'
  const containerClass = isPrimary ? 'btn-create-label' : 'btn-create-label-batch'
  const dividerClass = isPrimary ? 'create-label-divider' : 'create-label-batch-divider'

  return (
    <div
      className={clsx('btn-group rounded', containerClass, {
        'w-100': fullWidth,
      })}
      role='group'
    >
      <button
        type='button'
        className={clsx(
          'btn btn-sm bg-transparent border-0 d-flex align-items-center justify-content-center gap-2 fw-bolder',
          {'flex-grow-1': !isPrimary}
        )}
        style={{width: '90%'}}
        onClick={onMainClick}
        disabled={loading || disabled}
      >
        {icon}
        <span
          className={clsx('indicator-label', {
            'text-white text-nowrap text-truncate': isPrimary,
          })}
        >
          {label}
        </span>
      </button>

      <div className={dividerClass} />

      <button
        type='button'
        className='btn btn-sm bg-transparent border-0 h-100 d-flex align-items-center justify-content-center'
        style={{width: '10%'}}
        data-bs-toggle='dropdown'
        aria-expanded='false'
        disabled={loading || disabled}
      >
        <KTSVG
          path='/media/gori/arrows/arrow_down.svg'
          className={clsx('svg-icon-2 me-0', {'text-white': isPrimary, 'text-primary': !isPrimary})}
        />
      </button>

      <ul
        className={clsx('mt-5 dropdown-menu dropdown-menu-end', {
          'create-label-dropdown-menu': isPrimary,
          'create-label-dropdown-menu-light': !isPrimary,
        })}
        style={{minWidth: '100%'}}
      >
        {options.map((option) => (
          <li key={option.id}>
            <div
              onClick={() => onSelectOption(option.id)}
              className={clsx('dropdown-item-custom', {active: selectedOption === option.id})}
            >
              {option.label}
            </div>
          </li>
        ))}
      </ul>
    </div>
  )
}

export {SplitButtonDropdown}
